// extracted by mini-css-extract-plugin
module.exports = {"PlacesGrid":"PlacesGrid_PlacesGrid__G6LxQ"};